import React, { useState, useCallback } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import styled from 'styled-components';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { API_HOST } from '../../consts';
import logo from '../../assets/img/logo.svg';

const SearchStudentsPage = (props) => {
  const { className } = props;
  const [userIdentification, setUserIdentification] = useState('');
  const [records, setRecords] = useState([]);

  const handleUserIdentificationChange = (event) => {
    setUserIdentification(event.target.value);
  };

  const fetchStudent = useCallback(
    (identification = userIdentification) => {
      axios
        .get(
          `${API_HOST}/academico/alunos_egressos?nome=${identification}`
        )
        .then((response) => {
          if (response.data.results.length === 0) {
            toast.error(`Aluno não encontrado`);
          }
          setRecords(response.data.results);
        })
        .catch(() => {
          toast.error(`Aluno não encontrado`);
        });
    },
    [userIdentification]
  );

  const handleSubmit = (event) => {
    fetchStudent();
    event.preventDefault();
  };

  return (
    <div className={className}>
      <nav className="main-header">
        <ul>
          <li className="logo">
            <Link to="/">
              <img
                width={200}
                src={logo}
                className="navigation-logo"
                alt="CMMG"
              />
            </Link>
          </li>
        </ul>
      </nav>
      <div className="body-container">
        <div className="w-90 content-container">
            <form onSubmit={handleSubmit}>
              <div className="input-label">
              Utilize o campo abaixo para realizar a pesquisa de alunos registrados na instituição.
              </div>
              <div className="input-label">
              Lembre-se de digitar tudo em letras maiúsculas e sem acentuação.
              </div>
              <input
                className="input-userid"
                placeholder="Digite o Nome Completo"
                type="text"
                value={userIdentification}
                onChange={handleUserIdentificationChange}
              />
              {userIdentification &&
              <button className="search-button" type="submit">
                <FontAwesomeIcon icon="search" />
              </button>
              }
            </form>
            <br/>
            <div className='w-90'>
              {records.map(d =>
                <div className="usuario-card">
                  <div className="d-flex align-items-center">
                    <div className="d-flex flex-direction-column">
                    <div className='d-flex flex-direction-row justify-space-between'>
                      <div className='d-flex flex-direction-column'>
                      <span className="semi-bold">ALUNO(A) CERTIFICADO(A): </span>
                        <strong className="mt-1 mb-1 green font-20">
                          {d.nome}
                        </strong>
                      </div>
                    </div>
                      <br/>
                      <a className="mt-1 mb-1 green font-16">
                        CURSO:
                      </a>
                      <span>{d.curso}</span>
                      <br/>
                      <a className="mt-1 mb-1 green font-16">
                        INSTITUIÇÃO EXPEDIDORA DO CERTIFICADO:
                      </a>
                      <span>351 - FACULDADE DE CIÊNCIAS MÉDICAS DE MINAS GERAIS</span>
                      <br/>
                      {/* <a className="mt-1 mb-1 green font-16">
                        INSTITUIÇÃO REGISTRADORA DO DIPLOMA
                      </a>
                      <span>575 - UNIVERSIDADE FEDERAL DE MINAS GERAIS - UFMG</span> */}
                      <br/>
                      <div className='d-flex flex-direction-column'>
                        <a className="mt-1 mb-1 green font-16">
                          CONCLUSÃO DO CURSO EM:
                        </a>
                        <span>{d.termino_do_curso}</span>

                      </div>

                        <br/>
                        <br/>
                        <span>Para maiores informações gentileza entrar em contato com a instituição.</span>
                        <br/>
                    </div>
                  </div>
                </div>
              )}
            </div>
        </div>
      </div>
    </div>
  );
};


export default styled(SearchStudentsPage)`
.input-label {
  margin-bottom: 10px
  text-align: center;
}

.search-button {
  background-color: #039f97;
  border: none;
  border-radius: 4px;
  color: white;
  padding: 8px 16px;
  cursor: pointer;
  margin-left: -45px;
}

.search-button:hover {
  -webkit-box-shadow: 0 5px 7px 0 rgba(0, 0, 0, 0.15);
  -moz-box-shadow: 0 5px 7px 0 rgba(0, 0, 0, 0.15);
  box-shadow: 0 5px 7px 0 rgba(0, 0, 0, 0.15);
}

.content-container {
  display:flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.input-userid {
  width:83%;
  height: 30px;
  margin-left: 35px;
}
.body-container {
  padding-top: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

}
.main-header {
  top: 0;
  left: 0;
  z-index: 10;
  color: white;
  width: 100%;
  height: 6rem;
  background: #039f97;
  padding: 0;
  position: block;
  ul {
    list-style: none;
    display: flex;
    align-items: center;
    -webkit-box-align: center;
    justify-content: space-between;
    -webkit-box-pack: justify;
    margin: auto;
    padding: 15px 25px;

    .logo {
      align-self: center;
    }

    li {
      margin-right: 20px;
      &:last-child {
        margin-right: 0;
      }
    }
  }
`;
